module.exports = __webpack_public_path__ + "img/0220624180649.ab313462.png";